var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGcp = function SvgGcp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4535",
    d: "M12.832 6.423h.068l-.034-.034L15.256 4v-.052A7.79 7.79 0 0 0 7.88 2.325a7.79 7.79 0 0 0-5.276 5.413.3.3 0 0 1 .137-.034 5.6 5.6 0 0 1 4.15-.82c.016-.017.033-.017.05-.017a4.304 4.304 0 0 1 5.909-.444z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#557EBF",
    d: "M17.528 7.704A7.73 7.73 0 0 0 15.17 3.93l-2.442 2.425a4.29 4.29 0 0 1 1.588 3.415v.427c2.886 0 2.886 4.304 0 4.304H9.98v3.415h-.017l.017.034h4.337a5.64 5.64 0 0 0 5.43-3.945 5.6 5.6 0 0 0-2.22-6.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#36A852",
    d: "M5.728 17.967h4.491v-3.45H5.728c-.325 0-.632-.068-.922-.187L2.21 16.823v.034a6.05 6.05 0 0 0 3.535 1.127z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9BC15",
    d: "M5.933 6.697C3.388 6.714 1.134 8.285.315 10.59c-.82 2.322 0 4.867 2.015 6.37l2.664-2.545c-1.469-.632-1.81-2.476-.683-3.552 1.127-1.093 3.04-.751 3.705.65l2.664-2.545C9.553 7.55 7.794 6.714 5.933 6.73z"
  })));
};
export default SvgGcp;